import { FeatureRequestState } from '@/types'
import { Divider } from '../base/divider'
import { Subheading } from '../base/heading'
import { Badge } from './badge'

interface Props {
  featureRequest: {
    id: string
    title: string
    description: string
    state: FeatureRequestState
  }
}

export const FeatureRequest = ({ featureRequest }: Props) => {
  return (
    <div className="p-4 rounded-xl border border-zinc-700 bg-zinc-800 flex flex-col gap-2">
      <span className="flex flex-row gap-2 items-center">
        <Subheading level={3}>{ featureRequest.title }</Subheading>
        <Badge state={featureRequest.state} />
      </span>
      <Divider />
      <p>{ featureRequest.description }</p>
    </div>
  )
}
